"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productsContext = exports.ProductsProvider = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const productsContext = exports.productsContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const {
  Provider
} = productsContext;
const ProductsProvider = ({
  children,
  value
}) => {
  const [products, setProducts] = (0, _react.useState)(value);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: (0, _react.useMemo)(() => ({
      products,
      setProducts
    }), [products]),
    children: children
  });
};
exports.ProductsProvider = ProductsProvider;
